
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 130.36 130.36"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#a3680a","stroke-miterlimit":"10","data-name":"レイヤー 2"}},[_c('path',{attrs:{"d":"M108 51.75a5.17 5.17 0 00-1.49-3.81l-7.55-7.46a5.21 5.21 0 00-7.46 0L57.63 74.22 38.89 55.48a5.21 5.21 0 00-7.46 0l-7.55 7.46a5.17 5.17 0 00-1.49 3.81 5.06 5.06 0 001.49 3.73l30 30a5.1 5.1 0 003.73 1.58 5.19 5.19 0 003.81-1.58l45-45a5.06 5.06 0 001.58-3.73zm20.89 13.43a62.29 62.29 0 01-8.54 32 63.39 63.39 0 01-23.17 23.17 62.29 62.29 0 01-32 8.54 62.29 62.29 0 01-32-8.54A63.39 63.39 0 0110 97.14a62.29 62.29 0 01-8.54-32 62.29 62.29 0 018.54-32A63.39 63.39 0 0133.21 10a62.29 62.29 0 0132-8.54 62.29 62.29 0 0132 8.54 63.39 63.39 0 0123.17 23.17 62.29 62.29 0 018.48 32.01z","fill":"#c4871a","stroke-width":"3"}}),_c('circle',{attrs:{"cx":"66.12","cy":"66.17","r":"61.68","fill":"none","stroke-width":"5"}})])])
          )
        }
      }
    